module.exports = __webpack_public_path__ + "static/media/D84.c6358df0.svg";